export default __webpack_public_path__ + "img/eMlvvRSZ.a6bf5ed8.svg";